import { io } from 'socket.io-client';

export const createWebsocketInstance = () => {
  const url = process.env.REACT_APP_WEB_SOCKET_URL;
  return io(url, { withCredentials: true, transports: ['websocket'], path: '/ws' });
};
